<template>
  <AbsPopup id="UiconPopup" :isTitle="isTitle" :title="title" :titleState="titleState" :type="this.option.param.type" :require="this.option.param.require" :initButtonList="initButtonList" @close="$emit('close')" @submit="submit">
    <template #body>
      <div class="popup-body">
        <icon v-if="icon" size="xxlarge" :state="iconstate" :uicon="icon" />
        <span v-if="target" v-html="target"></span>
        <span v-html="message"></span>
        <span v-if="description" class="description" v-html="description"></span>
      </div>
    </template>
  </AbsPopup>
  <!-- <div>
    <div class="modal-body">
      <icon v-if="icon" size="xxlarge" :class="iconstate" :uicon="icon" />
      <span v-if="target">{{ target }}</span>
      <span>{{ message }}</span>
    </div>
    <UbuttonList class="modal-footer" size="small" align="center" :data="buttonList"/>
  </div> -->
</template>

<script>
import AbsPopup from '@/components/popup/AbsPopup.vue'

export default {
  props: {
    option: {
      type: Object
    }
  },
  data: function () {
    return {
    }
  },
  created () {
    this.$emit('loading', false)
  },
  name: 'UiconPopup',
  computed: {
    isTitle () {
      return this.option.param !== undefined && this.option.param.title !== '' && this.option.param.title !== undefined
    },
    title () {
      return (this.option.param) ? this.option.param.title : ''
    },
    titleState () {
      return (this.option.param) ? this.option.param.titleState : ''
    },
    message () {
      return (this.option.param) ? this.option.param.message : ''
    },
    description () {
      return (this.option.param) ? this.option.param.description : ''
    },
    icon () {
      return this.option.param.icon
    },
    target () {
      return this.option.param.target
    },
    iconstate () {
      switch (this.option.param.type) {
        case 'confirm' :
          return (this.option.param.require) ? 'require' : 'deactive'
        case 'alert' :
          return (this.option.param.require) ? 'require' : 'active'
      }
    },
    initButtonList () {
      switch (this.option.param.type) {
        case 'confirm' :
          if (this.option.param.submitText) {
            return [
              {name: '취소', state: 'deactive', click: () => { this.$emit('close') }},
              {name: this.option.param.submitText, state: this.iconstate, click: this.submit}
            ]
          } else {
            return null
          }
        case 'alert' :
          if (this.option.param.buttonText) {
            console.log(this.components)
            return [
              {name: this.option.param.buttonText, state: this.iconstate, click: () => { this.$emit('close') }}
            ]
          } else {
            return null
          }
      }
    }
  },
  methods: {
    submit () {
      console.log('submit')
      this.$emit('submit', this.option.param.param)
    }
  },
  components: {
    AbsPopup
  }
}
</script>

<style scoped>
.popup-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px 0;
  padding: 0px 20px;
  color: var(--text-base);
  line-height: 1.5em;
}
.popup-body > .u_icon {
  margin-bottom: 20px;
}
.popup-body > span {
  margin-bottom: 20px;
}
/* .modal-footer {
  display: flex;
  width: 100%;
  justify-content: space-around;
} */
</style>



// WEBPACK FOOTER //
// src/components/popup/UiconPopup.vue